var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseCircleUnfilled = function SvgCloseCircleUnfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.83 11.83a1 1 0 0 1-.71-.295L8 9.415l-2.12 2.12a1.001 1.001 0 0 1-1.415-1.415L6.585 8l-2.12-2.12A1 1 0 1 1 5.88 4.465L8 6.585l2.12-2.12a1 1 0 1 1 1.415 1.415L9.415 8l2.12 2.12a1.001 1.001 0 0 1-.705 1.71ZM8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2Zm0 14A8 8 0 1 1 8 0a8 8 0 0 1 0 16Z"
  })));
};
export default SvgCloseCircleUnfilled;